<template>
  <div class="footer-bottom">
    <div>
      合作伙伴：
          <a href="https://www.linkedin.com/" rel="nofollow" target="_blank">
            LinkedIn
          </a>
          <a href="https://www.zhaopin.com/" rel="nofollow" target="_blank">
            智联招聘
          </a>
          <a href="https://www.51job.com/" rel="nofollow" target="_blank">
            前程无忧
          </a>
          <a href="https://www.liepin.com/" rel="nofollow" target="_blank">
            猎聘
          </a>
          <a href="https://www.wenjuan.com/?utm_source=cjjl" rel="nofollow" target="_blank">
            问卷网
          </a>
          <a href="http://www.onlinedown.net/" rel="nofollow" target="_blank">
            华军软件园
          </a>
    </div>
    <div>
      友情链接（+QQ:2549723159）：
      <a href="https://www.jobmail.club/" target="_blank">简历模板</a>
      <!-- <a href="https://www.paperccb.com/" target="_blank">论文查重</a> -->
      <a href="https://www.showmebug.com/" target="_blank">ShowMeBug</a>
        <a href="http://www.eduei.com/ruc" target="_blank">人民大学在职研究</a>
        <a href="https://jh.597.com/" target="_blank">金华人才网</a>
        <a href="https://gcjob.bjx.com.cn/" target="_blank">工程师招聘</a>
        <!-- <a href="https://www.xiaoxizn.com" target="_blank">简历解析</a> -->
        <a href="http://www.zaojiance.com" target="_blank">论文查重</a>
        <a href="https://www.tuzhuhu.com/" target="_blank">建筑工程</a>
        <!-- <a href="http://sh.jiajiaoban.com/" target="_blank">小学1对1辅导</a> -->
        <!-- <a href="https://www.91yu.com/" target="_blank">翡翠</a> -->
        <!-- <a href="http://www.job.cn" target="_blank">中国工作网</a> -->
        <!-- <a href="https://www.hellokidvip.com/" target="_blank">在线英语</a> -->
        <!-- <a href="https://www.boxuegu.com/" target="_blank">IT在线教育</a> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'FooterLink',
  data() {
    return {

    }
  },
}
</script>
<style lang="scss" scoped>
.footer-bottom {
  width: 790px;
  margin: auto;
  line-height: 18.5px;
  color: #9b9b9b;
  margin-top: 40px;
  a {
    margin-right: 4px;
    color: #9b9b9b;
    font-size: 13px;
  }
}
</style>
